import {create} from '@wix/fedops-logger';

const logger = create('marketing-template-viewer');

export default logger;
